import React from 'react';

import { Route, Routes } from 'react-router';

import { FailedSsoView } from './components/FailedSsoView';
import { ForgotPasswordView } from './components/ForgotPasswordView';
import { LegacySsoRedirectView } from './components/LegacySsoRedirectView';
import { LoginView } from './components/LoginView';
import { LogoutView } from './components/LogoutView';
import { PrivacyPolicyView } from './components/privacyPolicy/PrivacyPolicyView';
import { ResetPasswordView } from './components/ResetPasswordView';
import { SignedInView } from './components/SignedInView';
import { TwoFactorView } from './components/twoFactor/TwoFactorView';

const LoginRoutes = () => (
    <Routes>
        <Route path="/" element={<LoginView />} />
        <Route path="/forgot-password" element={<ForgotPasswordView />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyView />} />
        <Route path="/reset-password" element={<ResetPasswordView />} />
        <Route path="/set-password" element={<ResetPasswordView isSetPassword />} />
        <Route path="/two-factor" element={<TwoFactorView />} />
        <Route path="/signed-in" element={<SignedInView />} />
        <Route path="/logout" element={<LogoutView />} />
        <Route path="/sso/failed/:provider" element={<FailedSsoView />} />
        <Route path="/sso/legacy/:provider" element={<LegacySsoRedirectView />} />
        <Route path="*" element={<LoginView />} />
    </Routes>
);

export default LoginRoutes;
